import React from "react";
import { Route } from "react-router";
import "./custom.css";
import { Selector } from "./components/Selector";
import { LaunchError } from "./components/LaunchError";
import { Instruction } from "./components/Instruction";
import { Layout } from "./components/Layout";
import clientStorage from "./clientStorage";
import { Home } from "./components/Home";

const App = () => {
  // Obtain the auth token.
  const tokenParamName = "t";

  const url = new URL(window.location.href);
  const encodedToken = url.searchParams.get(tokenParamName);
  if (encodedToken !== null && encodedToken !== "") {
    // Base64 decode and store the token.
    clientStorage.setAuthToken(atob(encodedToken));

    // Remove the encoded token from the URL.
    url.searchParams.delete(tokenParamName);
    if (window.history.replaceState) {
      window.history.replaceState(null, "", url);
    }
  }

  return (
    <Layout>
      <Route exact path="/" component={Home} />
      <Route path="/launch-error" component={LaunchError} />
      <Route path="/instruction" component={Instruction} />
      <Route path="/selector" component={Selector} />
    </Layout>
  );
};

export default App;
